<mat-toolbar color="primary">
  <div>
    <button mat-icon-button (click)="onToggleSidenav()">
      <mat-icon>menu</mat-icon>
    </button>
  </div>
  <div fxHide.lt-xs>
    <a routerLink="/">
      AdFeeder
    </a>
  </div>
  <div fxFlex fxLayout fxLayoutAlign="flex-end" fxHide fxShow.gt-sm>
    <ul fxLayout fxLayoutGap="10px" class="navigation-items">
      <li class='listtt' *ngIf="!isAuth">  <a routerLink="/signup">Signup</a> </li>
      <li class='listtt' *ngIf="!isAuth">  <a routerLink="/login">Login</a></li>
      <!--<li class='listtt' *ngIf="isAuth">   <a [routerLinkActive]="['active']" routerLink="/listtrans">Translations</a></li> <span *ngIf="isAuth">|</span>
      <li class='listtt' *ngIf="isAuth">   <a [routerLinkActive]="['active']" routerLink="/listdealers">Dealers</a></li> <span *ngIf="isAuth">|</span>
      
      <li class='listtt' *ngIf="isAuth" [routerLinkActive]="['active']">   <a routerLink="admaker" [queryParams]="{ themetype: 'custom' }">Client Themes</a></li> <span *ngIf="isAuth">|</span>
      <li class='listtt' *ngIf="isAuth" [routerLinkActive]="['active']">   <a routerLink="admaker" [queryParams]="{ themetype: 'default' }">Themes</a></li> <span *ngIf="isAuth">|</span>
      <li class='listtt' *ngIf="isAuth">   <a [routerLinkActive]="['active']" routerLink="/process-select">Process Runner</a></li> <span *ngIf="isAuth">|</span>
      <li class='listtt' *ngIf="isAuth">   <a [routerLinkActive]="['active']" routerLink="/processlog">Missing Translations</a></li> <span *ngIf="isAuth">|</span>
      <li class='listtt' *ngIf="isAuth">   <a [routerLinkActive]="['active']" routerLink="/processlogclie">Missing Translations(Clientwise)</a></li> <span *ngIf="isAuth">|</span>-->
      <li class='listtt' *ngIf="isAuth">   <a style="cursor:pointer" (click)="onLogout()">Logout</a></li>
    </ul>
  </div>
</mat-toolbar>
